<div *ngIf="model.alertData$()">
  <div class="d-flex">
    <div class="col-sm-12">
      <h1>{{'t.alertViewLabel15' | translate}} {{model.alertData$()?.title}}</h1>
    </div>
    <div style = "flex: auto">
      <img *ngIf="model.alertData$()?.alertRuleType === 'AI'" class="img" src="/assets/icons/alert-modal-ai-icon.svg" alt="" />
    </div>
  </div>
<div class="lcs-modal-content-container">
    <div  class="row p-1">
      <div class="col-sm-6 mobile-padding">
        <div class="card" style="height: 100%;">
          <div class="card-header">
            {{'t.alertViewLabel16' | translate}}
          </div>
          <div class="card-body" style="padding: 50px;" >
              <div class ="alert-status">
                            <span class ="status-icon">
                              <img *ngIf="model.alertData$()?.status === AlertStatus.OPEN" class="img" src="/assets/icons/Current Status - Open.svg" width="30" height="30" alt="" />
                              <img *ngIf="model.alertData$()?.status === AlertStatus.CLOSED" class="img" src="/assets/icons/Current Status - Closed.svg" width="30" height="30" alt="" />
                              <img *ngIf="model.alertData$()?.status === AlertStatus.ACKNOWLEDGED" class="img" src="/assets/icons/Ack-Icon.svg" width="30" height="30" alt="" />
                            </span>

                <div>
                  <div *ngIf ="model.alertData$()?.status === AlertStatus.OPEN" style="margin: 3px;">{{'t.ticketStatusOpen' | translate}}</div>
                  <div *ngIf ="model.alertData$()?.status === AlertStatus.CLOSED" style="margin: 3px;">{{'t.alertMonitorStateClosed' | translate}}</div>
                  <div *ngIf ="model.alertData$()?.status === AlertStatus.ACKNOWLEDGED" style="margin: 3px;">{{'t.alertAckStatus' | translate}}</div>
                </div>

              </div>
            <div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 mobile-padding">
        <div class="card" style="height: 100%;">
          <div class="card-header">
            {{'t.alertWhenLabel' | translate}}
          </div>
          <div class="card-body">
            <div class="wrapper">
              <div *ngIf= "model.alertData$()?.status === AlertStatus.OPEN" class="date">
                <div>
                  <span class="label">{{'t.alertOpenLabel' | translate}}</span> &nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.openDatetime}}</span>
                </div>
                <div>
                  <span class="label">{{'t.alertAgeLabel' | translate}}</span> &nbsp;
                  <span>{{model.alertData$()?.openDuration}} </span>
                </div>
              </div>
              <div *ngIf= "model.alertData$()?.status === AlertStatus.ACKNOWLEDGED" class="date">
                <div>
                  <span class="label">{{'t.alertOpenLabel' | translate}}</span> &nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.openDatetime}}</span>
                </div>
                <div>
                  <span class="label">{{'t.alertAckLabel' | translate}}</span> &nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.ackDatetime}}</span>
                </div>
                <div>
                  <span class="label">{{'t.alertAgeLabel' | translate}}</span> &nbsp;
                  <span>{{model.alertData$()?.openDuration}} </span>
                </div>
              </div>
              <div *ngIf= "model.alertData$()?.status === AlertStatus.CLOSED" class="date">
                <div *ngIf="model.alertData$()?.openDatetime">
                  <span class="label">{{'t.alertOpenLabel' | translate}}</span>&nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.openDatetime}}</span>
                </div>
                <div *ngIf="model.alertData$()?.ackDatetime && model.alertData$()?.ackDatetime !=='NA'">
                  <span class="label">{{'t.alertAckLabel' | translate}}</span> &nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.ackDatetime}}</span>
                </div>
                <div>
                  <span class="label">{{'t.alertMonitorStateClosed' | translate}}:</span> &nbsp;
                  <span class="alert-open-date">{{model.alertData$()?.closeDatetime}}</span>
                </div>
                <div>
                  <span class="label">{{'t.commonDuration' | translate}}: </span> &nbsp;
                  <span>{{model.alertData$()?.closeDuration}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  class="row p-1">
      <div class="col-sm-6 mobile-padding">
        <div class="card" style="height: 100%;">
          <div class="card-header">
            {{'t.alertWhereLabel' | translate}}
          </div>
          <div class="card-body h-100">
            <div class ="alert-where">
              <div>
                <div class="d-flex">
                  <div>
                    <div>
                          <span class="group group-plant" *ngIf="model.alertData$()?.plant">
                           <span class="label">{{'t.alertViewLabel8' | translate}}</span> &nbsp;
                          <span class="data-plant">{{model.alertData$()?.plant}}</span>
                         </span>
                    </div>
                    <div>
                          <span class="group group-line" *ngIf="model.alertData$()?.line">
                          <span class="label">{{'t.alertViewLabel6' | translate}}</span> &nbsp;
                          <span class="data-line">{{model.alertData$()?.line}}</span>
                          </span>
                    </div>
                    <div>
                          <span class="group group-asset" *ngIf="model.alertData$()?.asset">
                          <span class="label">{{'t.alertViewLabel4' | translate}}</span> &nbsp;
                          <span class="data-asset">{{model.alertData$()?.asset}}</span>
                          </span>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 mobile-padding">
        <div class="card" style="height: 100%;">
          <div class="card-header">
            {{'t.alertWhoLabel' | translate}}
          </div>
          <div class="card-body h-100">
            <div class="wrapper">
              <div class="viewed-alert-detail-wrapper">
                <div class="viewed-alert-detail">
                  {{'t.alertViewLabel3' | translate}}  {{model.alertData$()?.source}}
                </div>
              </div>
              <div class="message" *ngIf="model.alertData$()?.ackUserFirstName && model.alertData$()?.ackUserLastName">
                <div class="label">{{'t.alertViewLabel14' | translate}}  {{model.alertData$()?.ackUserFirstName}} {{model.alertData$()?.ackUserLastName}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  class="row p-1">
      <div class="col-sm-12 mobile-padding">
        <div class="card alert-description">
          <div class="card-header">
            {{'t.alertDescriptionLabel' | translate}}
          </div>
          <div class="card-body">
            <div>
              <div style="white-space: pre-line;" >
                <div #messageBox id="message-box"
                     class="viewed-alert-message">
                  {{model.alertData$()?.description}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="model.alertData$()?.remedy" class="row p-1">
      <div class="col-sm-12 mobile-padding">
        <div class="card">
          <div class="card-header">
            {{'t.alertSolutionLabel' | translate}}
          </div>
          <div class="card-body">
            <quill-editor [hidden]="true" [modules]="quillModules"></quill-editor>
            <quill-view [format]="'json'" [content]="model.alertData$()?.remedy?.richText"></quill-view>
          </div>
        </div>
      </div>
    </div>

    <div class="row p-1" >
      <div class="col-sm-12 mobile-padding">
        <div class="card alert-comments-section">
          <div class="card-header">
            {{'t.alertCommentSectionHeader' | translate}}
          </div>
          <div class="card-body alert-comments">
            <link-alert-comment [commentsList]="this.model.alertData$()?.commentList" [alertInstanceId]="this.model.alertData$()?.alertInstanceId" [alertRuleId]="this.model.alertData$()?.alertRuleId"></link-alert-comment>
          </div>

        </div>
      </div>
    </div>


  </div>
  <div>
    <div
      class="d-flex align-items-center">
      <div class="alert-feedback-text">
        <link-alert-feedback
          [alertData]="this.model.alertData$()"
          [thumb_up]="'assets/icons/thumb_up_white.svg'"
          [thumb_up_selected]="'assets/icons/thumb_up_selected_white.svg'"
          [thumb_down]="'assets/icons/thumb_down_white.svg'"
          [thumb_down_selected]="'assets/icons/thumb_down_selected_white.svg'" ></link-alert-feedback>
      </div>
     </div>
  </div>
</div>
